const PRINCIPLES = [
  { icon: 'ri-flag-2-line', t: '先求证再吃瓜', d: '优先引用官方口径与多方信源，可疑内容宁缺毋滥。' },
  { icon: 'ri-scales-3-line', t: '理性不站队', d: '呈现事实与脉络，不制造对立，不替任何一方下结论。' },
  { icon: 'ri-timer-line', t: '日更不断更', d: '今日重磅、本周必看、本月劲爆、年度盘点四级滚动更新。' },
  { icon: 'ri-secure-payment-line', t: '隐私与安全', d: '对投稿信源严格保密，对AI合成内容主动标注与辟谣。' },
];

const VOICES = [
  { name: '深夜补剧的桃子', text: '每天睡前刷一遍必吃大瓜的今日重磅，上班通勤都有谈资了。' },
  { name: '理性吃瓜研究员', text: '难得有编辑部把“求证”写在原则第一条，看完会去核对官方信源。' },
  { name: '追综艺的老周', text: '本周必看和年度盘点真的很懂，选题和复盘都在点子上。' },
];

export default function About() {
  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '必吃大瓜',
    url: 'https://sjzcq.cn/',
    description: '专注娱乐热闻的每日吃瓜资讯站，持续更新今日重磅、本周必看、本月最劲爆与年度盘点。',
    email: 'bichidagua@example.com',
  };
  const siteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '必吃大瓜',
    url: 'https://sjzcq.cn/',
    description: '必吃大瓜年度盘点、本月最劲爆、本周必看与今日重磅内容一网打尽。',
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(siteSchema) }}
      />

      <section id="about" className="mx-auto w-full max-w-6xl scroll-mt-16 px-4 py-10 md:px-6 md:py-14">
        <div className="grid gap-8 lg:grid-cols-2 lg:gap-12">
          {/* 品牌叙事 */}
          <div>
            <div className="flex items-center gap-3 border-b border-background-300 pb-4">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-compass-3-line text-lg" />
              </span>
              <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">关于必吃大瓜</h2>
            </div>
            <p className="mt-5 font-heading text-lg font-semibold leading-relaxed text-foreground-900">
              我们是一间只做一件事的“吃瓜编辑部”：把散落在各大平台的娱乐热闻，按时间与热度替你梳理成清晰的瓜田地图。
            </p>
            <p className="mt-4 text-[15px] leading-7 text-foreground-700">
              必吃大瓜的定位是娱乐资讯的内容编辑与把关人，而非单纯的流量搬运工。我们坚持用
              <span className="mx-1 rounded bg-accent-100 px-1 font-medium text-accent-800">今日重磅</span>记录当天最受关注的事件，用
              <span className="mx-1 rounded bg-primary-100 px-1 font-medium text-primary-700">本周必看</span>和
              <span className="mx-1 rounded bg-secondary-100 px-1 font-medium text-secondary-800">本月最劲爆</span>留住值得回味的高光，再用
              <span className="mx-1 rounded bg-foreground-950 px-1 text-background-50">年度盘点</span>复盘一整年的喧嚣。
            </p>
            <p className="mt-4 text-[15px] leading-7 text-foreground-700">
              我们相信，热闹之外更需要清醒。因此编辑部把“先求证再吃瓜”写在每一篇内容的开头，主动标注来源、跟进反转、提示AI合成内容的可能。让每一次围观，都不至于在真相面前翻车。
            </p>

            <div className="mt-6 grid grid-cols-3 gap-3">
              {[
                { n: '12000+', l: '累计追踪事件' },
                { n: '4 级', l: '内容滚动机制' },
                { n: '每日', l: '定时热闻更新' },
              ].map((s) => (
                <div key={s.l} className="rounded-xl border border-background-200 bg-background-50 p-4 text-center">
                  <p className="font-heading text-2xl font-black text-primary-600">{s.n}</p>
                  <p className="mt-1 text-xs text-foreground-500">{s.l}</p>
                </div>
              ))}
            </div>
          </div>

          {/* 原则 */}
          <div className="flex flex-col gap-6">
            <div>
              <h3 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
                <i className="ri-shield-check-line text-primary-500" /> 内容四项原则
              </h3>
              <div className="mt-4 grid gap-3 sm:grid-cols-2">
                {PRINCIPLES.map((p) => (
                  <div key={p.t} className="rounded-xl border border-background-200 bg-background-100 p-4">
                    <i className={`text-xl ${p.icon} text-accent-600`} />
                    <h4 className="mt-2 text-sm font-bold text-foreground-900">{p.t}</h4>
                    <p className="mt-1 text-xs leading-5 text-foreground-600">{p.d}</p>
                  </div>
                ))}
              </div>
            </div>

            <div className="rounded-2xl border border-background-200 bg-background-50">
              <h3 className="flex items-center gap-2 border-b border-background-200 px-5 py-3.5 font-heading text-base font-bold text-foreground-950">
                <i className="ri-chat-heart-line text-primary-500" /> 瓜友口碑
              </h3>
              <ul className="divide-y divide-background-100">
                {VOICES.map((v) => (
                  <li key={v.name} className="px-5 py-3.5">
                    <p className="text-sm leading-6 text-foreground-700">“{v.text}”</p>
                    <p className="mt-1.5 flex items-center gap-1.5 text-xs text-foreground-500">
                      <span className="flex h-5 w-5 items-center justify-center rounded-full bg-secondary-100 text-secondary-800">
                        <i className="ri-user-smile-line" />
                      </span>
                      {v.name}
                      <span className="text-accent-500">★★★★★</span>
                    </p>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}